export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-play-circle-91f71cfc8c1536e6912d28158214cb5a.svg";